import React, { Component } from 'react'
import style from './style.module.less'
import { Flex } from 'hljd'
import { Button } from 'hljd'
import { observer, inject } from 'mobx-react'
import {
  TAB_TASK,
  TAB_SIGN,
  TAB_CONTACT,
  CONTACT_MOBILE
} from '@components/JiaMeng/NewCustomer/constant'
import { isExperienceStore } from '@util'
import isEmpty from 'lodash/isEmpty'

@inject('detailStore')
@observer
class Content extends Component {
  getActions = (
    { setStoreData, openOrCloseContactModal, customerToLeads },
    type
  ) => {
    if (type == TAB_CONTACT) {
      return (
        <Button
          type="primary"
          onClick={() => openOrCloseContactModal(true, CONTACT_MOBILE)}
        >
          联系
        </Button>
      )
    } else if (type == TAB_TASK) {
      return (
        <Button
          type="primary"
          onClick={() =>
            setStoreData([{ type: 'taskModalVisible', value: true }])
          }
        >
          创建任务
        </Button>
      )
    } else if (type == TAB_SIGN) {
      if (isExperienceStore()) {
        return (
          <>
            <Button
              type="primary"
              onClick={customerToLeads}
              style={{ marginRight: 10 }}
            >
              派单
            </Button>

            <Button
              onClick={() =>
                setStoreData([
                  { type: 'insertCoopOrderModalVisible', value: true }
                ])
              }
              style={{ marginRight: 10 }}
            >
              录入合作订单
            </Button>
          </>
        )
      } else {
        return (
          <Button
            type="primary"
            onClick={() =>
              setStoreData([{ type: 'signModalVisible', value: true }])
            }
          >
            签单
          </Button>
        )
      }
    }
  }

  render() {
    const {
      detailStore: { formattedCardList, type }
    } = this.props

    return (
      <>
        <div style={{ textAlign: 'right' }}>
          {this.getActions(this.props.detailStore, type)}
        </div>

        {Object.keys(formattedCardList).map(date => {
          return (
            <div key={date}>
              <Flex className={style.header}>
                <div className={style.date}>
                  {date == 'latest' ? '即将到来' : date}
                </div>
              </Flex>

              {formattedCardList[date].map(item => {
                return <div key={item.id}>{this.props.renderItem(item)}</div>
              })}
            </div>
          )
        })}

        {isEmpty(formattedCardList) && (
          <div className="text-center" style={{ marginTop: 68 }}>
            <img
              src="//qnm.hunliji.com/o_1d8n44q421vnavmjs8kkg81fea9.png"
              style={{ width: 140, height: 120 }}
            />
            <div style={{ marginTop: 24, color: '#666' }}>暂无记录~</div>
          </div>
        )}
      </>
    )
  }
}

export default Content
